export enum UserRoles {
  ADMIN = 'ROLE_ADMIN',
  GROUPCOORDINATOR = 'ROLE_GROUPCOORDINATOR',
  GROUPADMIN = 'ROLE_GROUPADMIN',
  HD = 'ROLE_HD',
  REPORTS = 'ROLE_REPORTS',
  GROUPMANAGER = 'ROLE_GROUPMANAGER',
  GROUP = 'ROLE_GROUP',
  LOCMGR = 'ROLE_LOCMGR',
  USER = 'ROLE_USER',
  RETAIL = 'ROLE_RETAIL',
}
